module.exports = __webpack_public_path__ + "img/Group 427320380.72cecf5b.svg";